import { render, staticRenderFns } from "./Avancement.vue?vue&type=template&id=4388771c&"
import script from "./Avancement.vue?vue&type=script&lang=ts&"
export * from "./Avancement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports